<section>
  <section>
    <div class="processed-fields-container" *ngFor="let field of fileFields">
      <div class="dynamic-form-item-label process-label">{{ field.label }}  </div>
      <ng-container [ngSwitch]="field.type">
        <div class="process-value"  id="file_date" *ngSwitchCase="'date'">{{ field.value | date:'dd MMM yyyy'}}</div>
        <div class="process-value" id="file_{{field.label}}" *ngSwitchDefault>{{ field.value }}</div>
      </ng-container>
    </div>
  </section>
  <section>
    <div class="delete-button">
      <gen-button class="deleteButton" [text]="'Delete File'"  [textClass]="'deleteBtnClass'" [disabled]="disabled" (click)="deleteFile($event)"></gen-button>
    </div>
    <gen-info-box [iconType]="'info'" [message]="warningText" *ngIf="warningImageUrl" [borderCss]="'__border'"></gen-info-box>
  </section>

</section>
